import { Tag } from '../../../ontology.model';

export const sequencesTags: Tag[] = [
  {
    id: 'tag.seq',
    name: 'Sequences & Series',
    parent_id: 'tag.alg',
    icon: 'list-ol',
  },
];
